module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/canals-cleaned2.5ed14776.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/canals-cleaned2.png
// module id = 300
// module chunks = 0